export type AboutPoint = {
  title: string;
  description: string;
};

export const aboutPoints: AboutPoint[] = [
  {
    title: "Lean, collaborative delivery",
    description:
      "Weekly reviews, honest feedback, and rapid iterations keep your product aligned to customer needs while de-risking every release.",
  },
  {
    title: "Human-centered craft",
    description:
      "Research-backed UX, purposeful motion, and thoughtful content make your experience intuitive and memorable on every device.",
  },
  {
    title: "Reliability at scale",
    description:
      "We architect with resilience - observability, automation, and strong security practices built in from day one.",
  },
  {
    title: "Partners, not vendors",
    description:
      "We work as an embedded product team, helping you prioritize impact, validate quickly, and ship with confidence.",
  },
];
